import { get } from '../http'

export const getTopicInfoList = () => {
    return get({ path: '/app/camellia/delayQueue/getTopicInfoList', data: {} })
}

export const getMonitorData = () => {
    return get({ path: '/app/camellia/delayQueue/getMonitorData', data: {} })
}
